/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Successfullysignedin2Inputs */

const en_successfullysignedin2 = /** @type {(inputs: Successfullysignedin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Successfully signed in.`)
};

const de_successfullysignedin2 = /** @type {(inputs: Successfullysignedin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du bist angemeldet.`)
};

/**
* | output |
* | --- |
* | "Successfully signed in." |
*
* @param {Successfullysignedin2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const successfullysignedin2 = /** @type {((inputs?: Successfullysignedin2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Successfullysignedin2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_successfullysignedin2(inputs)
	return de_successfullysignedin2(inputs)
});
export { successfullysignedin2 as "successfullySignedIn" }